// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetLabelsResponse = App.Http.Responses.Label.GetLabelsResponse;
import GetLabelResponse = App.Http.Responses.Label.GetLabelResponse;
import GetLabelsRequest = App.Http.Requests.Label.GetLabelsRequest;
import GetLabelRequest = App.Http.Requests.Label.GetLabelRequest;
import StoreLabelRequest = App.Http.Requests.Label.StoreLabelRequest;
import UpdateLabelRequest = App.Http.Requests.Label.UpdateLabelRequest;
import DeleteLabelRequest = App.Http.Requests.Label.DeleteLabelRequest;

class LabelsApi extends TenantBaseApi {
    async index(request: GetLabelsRequest): Promise<GetLabelsResponse> {
        return await this.get<GetLabelsResponse, GetLabelsRequest>("/labels", {
            params: request,
        });
    }

    async show(labelId: string, request?: GetLabelRequest): Promise<GetLabelResponse> {
        return await this.get<GetLabelResponse, GetLabelRequest>(`/labels/${labelId}`, {
            params: request,
        });
    }

    async store(request: StoreLabelRequest): Promise<GetLabelResponse> {
        return await this.post<GetLabelResponse, StoreLabelRequest>("/labels", request);
    }

    async update(labelId: string, request: UpdateLabelRequest): Promise<GetLabelResponse> {
        return await this.patch<GetLabelResponse, UpdateLabelRequest>(`/labels/${labelId}`, request);
    }

    async destroy(labelId: string): Promise<GetLabelResponse> {
        return await this.delete<GetLabelResponse, DeleteLabelRequest>(`/labels/${labelId}`);
    }
}

export const labelsApi = new LabelsApi();
